import {
  type EWarehouseCategorySuggestionKind,
  type IAdminCategory,
  type IWarehouseCategorySuggestion,
} from '@mahawi/eshop-common/src/types';

import { type AsyncState } from '../async-state';

export enum EWarehouseCategorySuggestionsRunStatus {
  IDLE = 'idle',
  PREPARING = 'preparing',
  RUNNING = 'running',
  DONE = 'done',
  CANCELLED = 'cancelled',
  FAILED = 'failed',
}

export enum EWarehouseCategorySuggestionItemStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  SUGGESTED = 'suggested',
  NO_SUGGESTION = 'noSuggestion',
  FAILED = 'failed',
}

export interface IWarehouseCategorySuggestionItem {
  uuid: string;
  name: string;
  inStockProductsCount: number;
  status: EWarehouseCategorySuggestionItemStatus;
}

export interface ICategoriesState extends AsyncState {
  categories?: IAdminCategory[];
  likelyProductCategories: {
    uuids?: string[];
  };
  warehouseCategorySuggestions: {
    stage: EWarehouseCategorySuggestionKind;
    status: EWarehouseCategorySuggestionsRunStatus;
    items: IWarehouseCategorySuggestionItem[];
    suggestions?: IWarehouseCategorySuggestion[];
    batch: {
      current: number;
      total: number;
    };
    failedBatchesCount: number;
    cachedCount: number;
    startedAt?: number;
    finishedAt?: number;
    applyingUuids: string[];
  };
}
